// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__6mo7U","unreadBadge":"styles_unreadBadge__IAGTg","modalContent":"styles_modalContent__1N_65","modal":"styles_modal__3Atm3"};